const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const deleteInternalCodes = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: DeleteCampaignInternalCodes!) {
      deleteInternalCodes(input:$input){
        campaignId
        internalCodes{
          id
          internalCode
          internalLink
          city{
            id
            name
          }
        }
      }
    }`,
    {
      input: queryVars,
    },
  )
}
